import React, { ReactElement } from 'react';
import { strings } from 'src/localization';
import css from './AdditionalServicePanelDetail.module.scss';
import { Recom, CheckedRecom, VehicleRec, SpecData } from 'src/models';
import MoreDetails from 'src/components/MoreDetails/containers/MoreDetails';
import AdditionalServicePanelDetailMedia from './AdditionalServicePanelDetailMedia/AdditionalServicePanelDetailMedia';

export interface IProps {
    recom: Recom[];
    checkedRecoms: CheckedRecom[];
    serviceIndex: number;
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    specData?: SpecData;
    onToggle: (e: any, btnText: string) => void;
}

const AdditionalServicePanelDetail = (props: IProps) => {
    const serviceDescription = props.recom[props.serviceIndex].opDesc;
    const servicePrice = '$' + (Number(props.recom[props.serviceIndex].opPrice) / 100).toFixed(2);
    const serviceChecked =
        props.checkedRecoms.some(result => (result.opCode === props.recom[props.serviceIndex].opCode) ? true : false);
    const serviceWhat: ReactElement | string = props.recom[props.serviceIndex].opWhat;
    const serviceWhy: ReactElement | string = props.recom[props.serviceIndex].opWhy;

    const validMedia = props.recom[props.serviceIndex].urls.filter(
        result => result.opUrlType === 'I' || result.opUrlType === 'V');
    const mediaDisplay: JSX.Element[] | null = validMedia.map((panel, index) => <div
        key={props.serviceIndex + panel.opUrlLink + panel.opUrlType}
        className={css.mediaDisplay}
    >
        <AdditionalServicePanelDetailMedia
            key={index}
            id={panel.opUrlType + index}
            opDesc={props.recom[props.serviceIndex].opDesc}
            opUrlType={panel.opUrlType}
            opUrlLink={panel.opUrlLink}
            opUrlTrack={panel.opUrlTrack}
            vehicles={props.vehicles}
            selectedVehicle={props.selectedVehicle}
        />
    </div>);

    const displayWhy = serviceWhy ?
        <div style={{ display: 'block' }}>
            <div className={css.detailsSalesTool}>
                {strings.WhyDoINeedThis}
            </div>
            <div className={css.detailsText}>
                {serviceWhy}
            </div>
        </div> :
        null;

    const displayWhat = serviceWhat ?
        <div style={{ display: 'block' }}>
            <div className={css.detailsSalesTool}>
                {strings.WhatIsThisFor}
            </div>
            <div className={css.detailsText}>
                {serviceWhat}
            </div>
        </div> :
        null;

    return (
        <MoreDetails
            headerLit={strings.OperationDetails}
            onAddService={props.onToggle}
            addServiceBtn={!serviceChecked}
            vehicles={props.vehicles}
            selectedVehicle={props.selectedVehicle}>
            <div
                className={css.details}>
                <h4 id='h4LightBox' className={css.detailsTitle}>
                    {serviceDescription}
                </h4>
                <div className={css.mediaDisplayArea}>
                    {mediaDisplay}
                </div>

                <div className={css.detailsPrice}>
                    {props.specData?.showCustPrice === 'Y' && servicePrice}
                </div>

                {displayWhy}
                {displayWhat}
                <div className={css.detailsSalesTool}>
                    {strings.RecommendedVehicle}
                </div>
                <div className={css.detailsText}>
                    {strings.RecommendedLastVisit}
                </div>
            </div>
        </MoreDetails>
    );
};

export default AdditionalServicePanelDetail;